<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title class="text-uppercase">CẬP NHẬT THÔNG TIN LIÊN LẠC</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form ref="form">
          <v-text-field label="Họ tên" v-model="contact.buyerName" outlined hide-details />
          <v-text-field
            label="Số điện thoại"
            required
            type="tel"
            v-model="contact.phone"
            outlined
            :rules="[$rules.required, $rules.phone]"
            class="pt-6"
          />
          <v-text-field label="Email" type="email" v-model="contact.email" outlined :rules="[$rules.email]" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer />
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: { ...mapGetters({ profile: 'lead/item' }) },
  watch: {
    profile: {
      handler(val) {
        if (val) this.setFormValues(val)
      },
      immediate: true,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    contact: {
      buyerName: '',
      phone: '',
      email: '',
    },
  }),
  methods: {
    ...mapActions('lead', ['updateLead']),
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    setFormValues(profile) {
      this.contact.buyerName = profile.buyerName || ''
      this.contact.phone = profile.phone || ''
      this.contact.email = profile.email || ''
    },
    async submit() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return
      try {
        this.$loading.active = true
        await this.updateLead({ id: this.profile.id, ...this.contact })
        this.$alert.success('Cập nhật "Thông tin liên lạc" thành công')
        this.$emit('refresh')
        this.close()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
